import { CheckmarkFilled, WarningAltFilled } from '@carbon/icons-react';
import { Button } from '@ph-react-ui/core';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetPaymentResponse } from '../../hooks/payments/useGetPaymentResponse';
import { PAYMENT_TYPE } from '../../utils/constants/payments/payment-type';
import { displayPrice } from '../../utils/displayPrice';
import { PaymentTransactionStatus } from '../../utils/enums/payment-transaction-status';

export function PaymentResponse() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: paymentResponse } = useGetPaymentResponse(id);

  const onNavigateBack = () => {
    navigate('/dashboard/payments');
  };

  return (
    <div className="payments">
      <div className="payments__response">
        {paymentResponse?.status === PaymentTransactionStatus.Successful ? (
          <>
            <CheckmarkFilled className="payments__response__icon payments__response__icon-success" />
            <h3 className="payments__response__title">
              {t('PAYMENTS.TITLES.SUCCESSFUL_PAYMENT')}
            </h3>
          </>
        ) : (
          <>
            <WarningAltFilled className="payments__response__icon payments__response__icon-error" />
            <h3 className="payments__response__title">
              {t('PAYMENTS.TITLES.UNSUCCESSFUL_PAYMENT')}
            </h3>
          </>
        )}

        <div className="payments__pre-payment__student-section">
          <div className="payments__pre-payment__two-column-layout">
            <div className="payments__pre-payment__student-info">
              <p className="payments__pre-payment__label">
                {t('PAYMENTS.LABELS.PAYMENT_TYPE')}
              </p>
              {paymentResponse && (
                <p className="payments__pre-payment__value">
                  {t(PAYMENT_TYPE[paymentResponse.paymentType])}
                </p>
              )}
            </div>

            <div className="payments__pre-payment__installment-item payments__pre-payment__student-info--divider">
              <p className="payments__pre-payment__label">
                {t('PAYMENTS.LABELS.TRANSACTION_ID')}
              </p>
              <p className="payments__pre-payment__value">{id}</p>
            </div>
          </div>
        </div>

        <div className="payments__pre-payment__total-section">
          <div className="payments__pre-payment__total-row">
            <p className="payments__pre-payment__total-label">
              {t('PAYMENTS.LABELS.AMOUNT_PAID')}
            </p>
            <p className="payments__pre-payment__total-value">
              {displayPrice(
                paymentResponse?.amount || 0,
                t('PAYMENTS.LABELS.BGN'),
                t('PAYMENTS.LABELS.EUR'),
                paymentResponse?.currency!
              )}
            </p>
          </div>
        </div>

        <div className="payments__response__actions">
          <Button compact onClick={onNavigateBack}>
            {t('ACTIONS.CLOSE')}
          </Button>
        </div>
      </div>
    </div>
  );
}
